export default __webpack_public_path__ + "static/media/nftbe.9a607e53.gif";